//@flow
import React, {useEffect, useState} from 'react';
import SwitchableSection from '../../../../../elements/SwitchableSection';
import {ImageButton} from '../../../../my-store/customize/components/ImageButton/ImageButton';
import {useTypedSelector} from '../../../../../store';
import {getImageUrl} from '../../../../../utils/image_provider';

import {actions} from '../../../../my-store/customize/duck';
import {useBindedActions} from '../../../../../utils/globalStore';
import SnackBar from '../../../../../elements/SnackBar/SnackBar';
import {useIsFeatureInTier} from '../../../../../utils/component';

export default function CoverSection() {
  const [enabledCover, setEnabledCover] = useState<boolean>(false);
  const [coverImage, setCoverImage] = useState<string | null>(null);
  const [coverImageFile, setCoverImageFile] = useState<File | null>(null);

  const saveSuccess = useTypedSelector(
    state => state.myStore.saveStoreInformationSuccess
  );
  const isSaving = useTypedSelector(state => state.myStore.isSaving);
  const {saveStoreInformation} = useBindedActions(actions);
  const storeInformation = useTypedSelector(state => state.ui.storeInformation);

  const shouldUpdateInfo = useIsFeatureInTier('STORE_INFORMATION');

  useEffect(() => {
    if (storeInformation) {
      setEnabledCover(storeInformation.enabledCover);
      if (storeInformation.coverId)
        setCoverImage(getImageUrl(storeInformation.coverId));
    }
  }, [storeInformation]);

  const handleEnableCover = (value: boolean) => {
    saveStoreInformation({
      storeInformationRequest: {
        enabledCover: value,
      },
    });
  };

  const handleUpdateImageFile = (file: File | null) => {
    if (!shouldUpdateInfo) return;
    if (file) {
      setCoverImageFile(file);
      saveStoreInformation({
        storeInformationRequest: {
          coverId: enabledCover
            ? storeInformation?.coverId && !coverImage
              ? ''
              : undefined
            : undefined,
          coverImageFile: enabledCover ? file : undefined,
        },
      });
    } else {
      saveStoreInformation({
        storeInformationRequest: {
          coverId: '',
        },
      });
    }
  };

  return (
    <>
      <SnackBar
        mode="success"
        message={saveSuccess ? 'Guardado correctamente' : ''}
      />
      <SwitchableSection
        id="cover"
        title="Foto de portada"
        onToggleEnable={handleEnableCover}
        enabled={enabledCover}
        loading={isSaving}
        disabled={!shouldUpdateInfo}
        subtitle="Usa esta sección para presentarte al cliente y generar confianza antes de la compra. Recomendamos grabar un video en TikTok o Youtube y colocar el enlace."
      >
        {enabledCover && (
          <ImageButton
            placeholder="Sube foto de portada (1000x300)"
            image={coverImage}
            setImage={setCoverImage}
            imageFile={coverImageFile}
            setImageFile={handleUpdateImageFile}
            maxWidth={3840}
            maxHeight={2160}
            aspect={4}
            disabled={!shouldUpdateInfo}
          />
        )}
      </SwitchableSection>
    </>
  );
}
